export default "__VITE_ASSET__DD8S1j7z__"